<ad-richdropdown placeholder="{{placeholder}}" [style]="style" #dropdown styleClass="dsf-dropdown-arrow"
  [panelClass]="['dropdown']" [panelComponent]="filterListComponent" [panelComponentInputs]="filterListInput">
</ad-richdropdown>